import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { getResetByTag, rem, colors, zIndex } from '../../../styles';
import StyledSelectablePanelText from './selectable-panel.text.styles';
var defaultStyles = function defaultStyles(_ref) {
  var hasBorder = _ref.hasBorder,
    variant = _ref.variant;
  return /*#__PURE__*/css("bottom:0;color:", colors.navy_600, ";height:100%;left:0;line-height:1.2;margin:", rem(0, 0, 0, 0), ";padding-right:0;user-select:none;width:100%;&::before{content:'';height:100%;left:0;position:absolute;top:0;width:100%;z-index:", zIndex.zIndex__2, ";}&::after{bottom:0;content:'';left:0;position:absolute;right:0;width:auto;}", StyledSelectablePanelText, ":only-child{display:flex;flex-direction:column;height:inherit;}", hasBorder && variant === 'solid' && /*#__PURE__*/css("&::after{border-bottom:", rem(1), " solid ", colors.coolGray_500, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var resetStyles = getResetByTag('div');
var StyledSelectablePanelBd = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "ea6q46m0"
} : {
  target: "ea6q46m0",
  label: "StyledSelectablePanelBd"
})(resetStyles, defaultStyles);
export default StyledSelectablePanelBd;